import FormCheckboxRadio from 'components/common/FormCheckboxRadio';
import useLang from 'hooks/useLang';
import styled from 'styled-components';

const FILTER_RECEIVER_FAVORITE_NAME = 'filter-receiver-favorite-field';

const FormFavoriteCheckbox = ({ filtered, setFiltered }) => {
  const { t } = useLang();

  const isFavorited = filtered['favoriteSelected'] === 'yes';
  const isNoneFavorite = filtered['favoriteSelected'] === 'no';
  const isAllFavorite = filtered['favoriteSelected'] === 'all';

  const handleOnChange = (value) => {
    const newFiltered = {
      ...filtered,
      favoriteSelected: value,
    };

    setFiltered(newFiltered);
  };

  const renderFormCheckRadio1 = () => {
    const formCheckRadioClassName1 = FILTER_RECEIVER_FAVORITE_NAME + '1';

    return (
      <>
        <FormCheckboxRadio
          name={FILTER_RECEIVER_FAVORITE_NAME}
          className={`${formCheckRadioClassName1} favorited ${
            isFavorited ? 'active' : ''
          }`}
          label={t('button_yes')}
          isChecked={isFavorited ? true : false}
          onClick={() => handleOnChange('yes')}
          styles={{ marginRight: '0px' }}
        />
      </>
    );
  };

  const renderFormCheckRadio2 = () => {
    const formCheckRadioClassName2 = FILTER_RECEIVER_FAVORITE_NAME + '2';

    return (
      <>
        <FormCheckboxRadio
          name={FILTER_RECEIVER_FAVORITE_NAME}
          className={`${formCheckRadioClassName2} none-favorite ${
            isNoneFavorite ? 'active' : ''
          }`}
          label={t('button_no')}
          isChecked={isNoneFavorite ? true : false}
          onClick={() => handleOnChange('no')}
          styles={{ marginRight: '0px' }}
        />
      </>
    );
  };

  const renderFormCheckRadio3 = () => {
    const formCheckRadioClassName3 = FILTER_RECEIVER_FAVORITE_NAME + '3';

    return (
      <>
        <FormCheckboxRadio
          name={FILTER_RECEIVER_FAVORITE_NAME}
          className={`${formCheckRadioClassName3} all-favorite ${
            isAllFavorite ? 'active' : ''
          }`}
          label={t('button_all')}
          isChecked={isAllFavorite ? true : false}
          onClick={() => handleOnChange('all')}
          styles={{ marginRight: '0px' }}
        />
      </>
    );
  };

  return (
    <FormFavoriteCheckboxStyled>
      <Label>{t('receivers_filter_by_favourite_receiver')}</Label>
      <FormCheckWrap>
        {renderFormCheckRadio1()}
        {renderFormCheckRadio2()}
        {renderFormCheckRadio3()}
      </FormCheckWrap>
    </FormFavoriteCheckboxStyled>
  );
};

const FormFavoriteCheckboxStyled = styled.div`
  margin-bottom: 32px;
`;
const Label = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: var(--ds-c-grey-dark);

  margin-bottom: 8px;
`;

const FormCheckWrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
`;

export default FormFavoriteCheckbox;
